// @flow

import styled from 'styled-components'

const RoomListItem = styled.div`
  margin-bottom: 24px;
  position: relative;
`

export default RoomListItem



// WEBPACK FOOTER //
// ./src/components/space/RoomListItem.jsx